import React, { useEffect, useState } from "react"
import { Card, Container } from "react-bootstrap"
import ActionBar from "../../core/ActionBar"
import Pagination from "../../core/Pagination"
import AddEdit from "../AddEdit"
import API from "../../../common/API"
import { parsedUser } from "../../../common/GetCurrentUser"
import { useTranslation } from "react-i18next"

import Settings from "../../../common/Settings"
import Filter from "../../core/Filter/Filter"

import ModalProvider from "../ModalProvider"
import moment from "moment"

function OwnerRequestControl() {
  const [records, setRecords] = useState([])
  const [selectedItem, setSelectedItem] = useState<any>(null)
  const [isLoading, setIsLoading] = useState(false)
  const [readOnly, setReadOnly] = useState<boolean>(false)
  const [showAddEdit, setShowAddEdit] = useState(false)
  const [showEmployeeValidation, setShowEmployeeValidation] = useState(false)
  const user = parsedUser()
  const { t } = useTranslation("global")
  const [filterFields, setFilterFields] = useState([
    {
      name: "search",
      title: "Nombre propietario",
      htmlType: "text",
      dbType: "string",

      containerClass: "col-md-6 col-lg-4 col-12",
    },
  ])
  const toggleEmployee = (item?: any, readonly?: boolean | undefined) => {
    setShowEmployeeValidation(!showEmployeeValidation)
    setSelectedItem(item)
    if (readonly) {
      setReadOnly(true)
    }
    if (showEmployeeValidation) {
      bindDataRemote()
    }
  }

  const bindDataRemote = async () => {
    try {
      console.log("bindDataRemote")
      setIsLoading(true)
      let query = {
        organizationId: user.OrganizationId,
      }
      const request = await API.postAction("laborAccessRequest/list", query)
      if (request.data.status === "ok") {
        setRecords(request.data.response)
      }
    } catch (e) {
      console.error(e)
    } finally {
      setIsLoading(false)
    }
  }
  const approveOrDeny = async (
    section: "second" | "responsable",
    item: any,
    approve: boolean
  ) => {
    if (section === "second") {
      let request = await API.getAction(
        `laborAccessRequest/ApproveSecondRepresentative?laborAccessRequestId=${item.id}&approve=${approve}`
      )
    }
    if (section === "responsable") {
      let request = await API.getAction(
        `laborAccessRequest/ApproveRepresentative?laborAccessRequestId=${item.id}&approve=${approve}`
      )
    }
    bindDataRemote()
  }
  const [filterObj, setFilterObj] = useState({})
  const getFilterValues = obj => {
    console.log("obj", obj)
    setFilterObj(obj)
  }
  const [showLaboralRepresentative, setShowLaboralRepresentative] =
    useState(false)
  const toggleLaboralRepresentative = (item?: any) => {
    setSelectedItem(item)
    setShowLaboralRepresentative(!showLaboralRepresentative)
  }
  const toggleAddEdit = (item?: any) => {
    setShowAddEdit(!showAddEdit)
    setSelectedItem(item)
    if (showAddEdit) {
      bindDataRemote()
    }
  }
  useEffect(() => {
    bindDataRemote()
  }, [])
  return (
    <>
      {showLaboralRepresentative && (
        <ModalProvider
          toggle={toggleLaboralRepresentative}
          record={selectedItem}
        />
      )}
      {showAddEdit && <AddEdit toggle={toggleAddEdit} record={selectedItem} />}

      <Container fluid>
        <ActionBar
          title="CONTROL DE SOLICITUDES/PROPIETARIOS"
          // actions={
          //   <>
          //     <button
          //       className="btn btn-primary btn-sm me-2"
          //       type="button"
          //       onClick={() => toggleAddEdit()}
          //     >
          //       <i className="fa fa-plus " />
          //     </button>
          //   </>
          // }
        />

        <div className="my-4">
          <Filter
            title={t("Filter")}
            // toggleFilter={toggleFilter}
            fields={filterFields}
            filterAction={() => {
              bindDataRemote()
            }}
            setFilterFields={getFilterValues}
          />
        </div>

        <Card className="my-4">
          <Card.Body className="p-0">
            <div className="table-responsive">
              {records && records.length > 0 && (
                <table className="table table-striped">
                  <thead>
                    <tr>
                      <th>{t("Propetary Name")}</th>
                      {/* <th>{t("Address")}</th> */}
                      <th>{t("Representante")}</th>
                      <th>{t("Estatus del Repr.")}</th>
                      <th>{t("No. Aprobación")}</th>
                      <th>{t("No. Cardnet")}</th>
                      <th className="text-center">{t("Acceso")}</th>
                      <th>{t("2do Representante")}</th>
                      <th>{t("Estatus del 2do Repr.")}</th>
                      <th className="text-center">{t("Acceso")}</th>
                      <th>{t("Solicitud")}</th>
                      {/* <th>{t("Notes")}</th> */}
                      <th></th>
                    </tr>
                  </thead>
                  <tbody>
                    {records.map((item: any, index: number) => {
                      console.log(item)
                      return (
                        <tr key={index}>
                          <td
                            onClick={() => toggleEmployee(item)}
                            className="clickable"
                          >
                            {item.propetaryName}
                            {/* <br />
                          <small> {item.address}</small> */}
                          </td>

                          <td className="align-middle text-truncate">
                            {item.responsibleEngineerPicture && (
                              <img
                                src={`${Settings.BasePath}/files/${item.responsibleEngineerPicture}`}
                                width="50"
                                height="50"
                                className="rounded-circle me-2 "
                              />
                            )}
                            {item.responsableName ?? "-"}

                            <br />
                            {item.responsableApproved &&
                            item.responsableApproved === true ? (
                              <button
                                className="btn btn-sm btn-danger ms-2"
                                onClick={() =>
                                  approveOrDeny("responsable", item, false)
                                }
                              >
                                <span className="fa fa-thumbs-down me-2"></span>{" "}
                                Denegar
                              </button>
                            ) : item.responsableApproved === false ? (
                              <button
                                className="btn btn-sm btn-success ms-2"
                                onClick={() =>
                                  approveOrDeny("responsable", item, true)
                                }
                              >
                                <span className="fa fa-thumbs-up me-2"></span>{" "}
                                Aprobar
                              </button>
                            ) : (
                              item.responsableApproved === null && (
                                <div className="btn-group">
                                  <button
                                    className="btn btn-sm btn-success "
                                    onClick={() =>
                                      approveOrDeny("responsable", item, true)
                                    }
                                  >
                                    <span className="fa fa-thumbs-up me-2"></span>{" "}
                                    Aprobar
                                  </button>
                                  <button
                                    className="btn btn-sm btn-danger "
                                    onClick={() =>
                                      approveOrDeny("responsable", item, false)
                                    }
                                  >
                                    <span className="fa fa-thumbs-down me-2"></span>{" "}
                                    Denegar
                                  </button>
                                </div>
                              )
                            )}
                          </td>
                          <td className=" text-truncate">
                            {!item.responsableHasWarning ? (
                              <span className="badge badge-lg bg-success ms-2">
                                Sin ficha
                              </span>
                            ) : (
                              <span className="badge badge-lg bg-danger ms-2">
                                Fichado
                              </span>
                            )}
                          </td>
                          <td>
                            {item.responsableApproved &&
                            item.responsableApproved === true &&
                            item.responsableApprovalDate
                              ? moment(item.responsableApprovalDate).format(
                                  "YYYYMMDDHHmmSS"
                                )
                              : "-"}
                          </td>
                          <td>
                            <td>
                              {item.responsableApproved &&
                              item.responsableApproved === true &&
                              item.responsableApprovalDate
                                ? moment(item.responsableApprovalDate).format(
                                    "YYMDHmSS"
                                  )
                                : "-"}
                            </td>
                          </td>
                          <td className="text-center">
                            {item.responsableApproved &&
                            item.responsableApproved === true ? (
                              <span className="badge badge-lg bg-success ms-2">
                                Aprobado
                              </span>
                            ) : (
                              <span className="badge badge-lg bg-danger ms-2">
                                Denegado
                              </span>
                            )}
                          </td>
                          <td>
                            {item.secondResponsibleEngineerPicture && (
                              <img
                                src={`${Settings.BasePath}/files/${item.secondResponsibleEngineerPicture}`}
                                width="50"
                                height="50"
                                className="rounded-circle me-2 "
                              />
                            )}
                            {item.secondResponsableName ?? "-"}
                            <br />
                            {item.secondResponsableId &&
                            item.secondResponsableApproved &&
                            item.secondResponsableApproved === true ? (
                              <>
                                <label className="badge bg-success">
                                  Aprobado
                                </label>

                                <button
                                  className="btn btn-sm btn-danger ms-2"
                                  onClick={() =>
                                    approveOrDeny("second", item, false)
                                  }
                                >
                                  <span className="fa fa-thumbs-down me-2"></span>{" "}
                                  Denegar
                                </button>
                              </>
                            ) : item.secondResponsableId &&
                              item.secondResponsableApproved === false ? (
                              <>
                                <label className=" badge bg-danger ms-2">
                                  Denegado
                                </label>

                                <button
                                  className="btn btn-sm btn-success ms-2"
                                  onClick={() =>
                                    approveOrDeny("second", item, true)
                                  }
                                >
                                  <span className="fa fa-thumbs-up me-2"></span>{" "}
                                  Aprobar
                                </button>
                              </>
                            ) : item.secondResponsableId &&
                              item.secondResponsableApproved === null ? (
                              <>
                                <button
                                  className="btn btn-sm btn-success ms-2"
                                  onClick={() =>
                                    approveOrDeny("second", item, true)
                                  }
                                >
                                  <span className="fa fa-thumbs-up me-2"></span>{" "}
                                  Aprobar
                                </button>
                                <button
                                  className="btn btn-sm btn-danger ms-2"
                                  onClick={() =>
                                    approveOrDeny("second", item, false)
                                  }
                                >
                                  <span className="fa fa-thumbs-down me-2"></span>{" "}
                                  Denegar
                                </button>
                              </>
                            ) : null}
                          </td>
                          <td>
                            {item.secondResponsableId &&
                            !item.secondResponsableHasWarning ? (
                              <>
                                <br />
                                <span className="badge badge-lg bg-success">
                                  Sin ficha
                                </span>
                              </>
                            ) : item.secondResponsableId ? (
                              <>
                                <br />
                                <span className="badge bg-danger badge-lg">
                                  Con ficha
                                </span>
                              </>
                            ) : null}
                          </td>
                          <td className="text-center">
                            {item.secondResponsableApproved &&
                            item.secondResponsableApproved === true ? (
                              <span className="badge badge-lg bg-success ms-2">
                                Aprobado
                              </span>
                            ) : item.secondResponsableApproved &&
                              item.secondResponsableApproved === false ? (
                              <span className="badge badge-lg bg-danger ms-2">
                                Denegado
                              </span>
                            ) : null}
                          </td>
                          <td>
                            {item.responsableId && item.secondResponsableId ? (
                              item.secondResponsableApproved === null ||
                              item.responsableApproved === null ? (
                                <span className="badge badge-lg bg-warning">
                                  En Proceso
                                </span>
                              ) : (
                                <span className="badge badge-lg bg-success">
                                  Procesada
                                </span>
                              )
                            ) : item.responsableId &&
                              item.secondResponsableId === null ? (
                              item.responsableApproved === null ? (
                                <span className="badge badge-lg bg-warning">
                                  En Proceso
                                </span>
                              ) : (
                                <span className="badge badge-lg bg-success">
                                  Procesada
                                </span>
                              )
                            ) : null}
                          </td>
                          {/* <td>{item.notes}</td> */}
                          <td className="text-end">
                            <div className="btn-group">
                              {/* <button
                                className="btn btn-sm btn-primary  d-xs-none"
                                type="button"
                                onClick={() => {
                                  toggleLaboralRepresentative(item)
                                }}
                              >
                                <i className="fa fa-eye me-2" />
                                Representante Laboral
                              </button> */}
                              <button
                                className="btn btn-sm btn-primary  d-xs-none"
                                type="button"
                                onClick={() => {
                                  toggleAddEdit(item)
                                }}
                              >
                                <i className="fa fa-eye me-2" /> Solicitud
                              </button>
                              {/*
                            <button
                              className="btn btn-sm btn-primary "
                              type="button"
                              onClick={() => toggleAddEdit(item)}
                            >
                              <i className="fa fa-edit" />
                            </button> */}
                            </div>
                          </td>
                        </tr>
                      )
                    })}
                  </tbody>
                </table>
              )}
            </div>
          </Card.Body>
        </Card>
        <Pagination
          totalPages={1}
          currentPage={0}
          onPageChanged={() => {
            console.log("onPageChanged")
          }}
        />
      </Container>
    </>
  )
}

export default OwnerRequestControl
